import { render, staticRenderFns } from "./accession-configuration.component.vue?vue&type=template&id=f9947b5e&scoped=true&"
import script from "./accession-configuration.component.vue?vue&type=script&lang=ts&"
export * from "./accession-configuration.component.vue?vue&type=script&lang=ts&"
import style0 from "./accession-configuration.component.vue?vue&type=style&index=0&id=f9947b5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9947b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextField})
